export default __webpack_public_path__ + "static/media/LogoRoche.ead34a62.svg";